<!-- ================赛事活动-教研赛事/专题活动/成果展示====================-->
<template>
    <div class="edu-research-page">
        <home-head />
        <div class="edu-research-body">
            <div class="edu-research-inner">
                <!-- 标题区 -->
                <div class="edu-research-header">
                    <div class="edu-research-title-box">
                        <div class="edu-research-title">活动竞赛</div>
                        <div class="edu-research-subtitle">赛事报名 &nbsp;成果展示</div>
                    </div>
                    <div class="edu-research-actions">
                        <div class="back-btn" @click="goHome">
                            <span>返回首页</span>
                        </div>
                    </div>
                </div>

                <!-- 标签切换 -->
                <div class="edu-research-tabs">
                    <div class="tab-item" :class="{ active: activeTab === 'race' }" @click="changeTab('race')">教研赛事</div>
                    <div class="tab-item" :class="{ active: activeTab === 'activity' }" @click="changeTab('activity')">专题活动</div>
                    <div class="tab-item" :class="{ active: activeTab === 'achievement' }" @click="changeTab('achievement')">成果展示</div>
                </div>

                <!-- 赛事/活动筛选 -->
                <div class="edu-research-filter" v-if="activeTab !== 'achievement'" v-loading="loading">
                    <div class="filter-left">
                        <div class="filter-item">
                            <span class="filter-label">{{ activeTab === 'race' ? '竞赛状态' : '活动状态' }}</span>
                            <el-select class="filter-select" v-model="queryParams.status" clearable placeholder="请选择" @change="handleFilterChange">
                                <el-option v-for="item in statusList" :key="item.value" :label="item.name" :value="item.value" />
                            </el-select>
                        </div>
                        <div class="filter-item">
                            <span class="filter-label">{{ activeTab === 'race' ? '竞赛级别' : '活动级别' }}</span>
                            <el-select class="filter-select" v-model="queryParams.level" clearable placeholder="请选择" @change="handleFilterChange">
                                <el-option v-for="item in levelList" :key="item.dictKey" :label="item.dictValue" :value="item.dictKey" />
                            </el-select>
                        </div>
                        <div class="filter-item">
                            <span class="filter-label">{{ activeTab === 'race' ? '竞赛方向' : '活动方向' }}</span>
                            <el-select class="filter-select" v-model="queryParams.direction" clearable placeholder="请选择" @change="handleFilterChange">
                                <el-option v-for="item in directionList" :key="item.dictKey" :label="item.dictValue" :value="item.dictKey" />
                            </el-select>
                        </div>
                    </div>
                    <div class="filter-right">
                        <input class="search-input" type="text" placeholder="请输入关键词" v-model="queryParams.name" @keyup.enter="handleSearch" />
                        <div class="search-btn" @click="handleSearch">搜索</div>
                    </div>
                </div>

                <!-- 赛事/活动列表 -->
                <div class="event-list" v-if="activeTab !== 'achievement'" v-loading="loading">
                    <div class="event-card" v-for="item in dataList" :key="item.raceId || item.activityId" @click="handleCardClick(item)">
                        <div class="card-title" :title="item.raceName || item.activityName">{{ item.raceName || item.activityName }}</div>
                        <div class="card-time">活动时间：{{ formatTimeRange(item) }}</div>
                        <div class="card-cover">
                            <img class="img-100" :src="item.raceCover || item.activityCover || defaultCover" :alt="item.raceName || item.activityName" />
                            <div class="card-status" :class="statusClass(item.status)">{{ statusLabel(item.status) }}</div>
                        </div>
                        <div class="card-info">
                            <div class="card-info-item">
                                <span class="info-label">{{ activeTab === 'race' ? '竞赛级别' : '活动级别' }}：</span>
                                <span class="info-value">{{ item.raceLevelName || item.activityLevelName || '--' }}</span>
                            </div>
                            <div class="card-info-item">
                                <span class="info-label">{{ activeTab === 'race' ? '竞赛方向' : '活动方向' }}：</span>
                                <span class="info-value">{{ item.raceDirectionName || item.activityDirectionName || '--' }}</span>
                            </div>
                            <div class="card-info-item">
                                <span class="info-label">{{ activeTab === 'race' ? '竞赛负责' : '活动负责' }}：</span>
                                <span class="info-value">{{ item.raceLeaderName || item.activityLeaderName || item.leaderName || '--' }}</span>
                            </div>
                            <div class="card-info-item">
                                <span class="info-label">主办单位：</span>
                                <span class="info-value">{{ item.hostOrgName || '--' }}</span>
                            </div>
                        </div>
                    </div>
                </div>

                <!-- 成果展示 -->
                <div class="achievement-list" v-if="activeTab === 'achievement'">
                    <div class="achievement-card" v-for="(item, index) in achievementList" :key="index" @click="handleAchievementClick(item)">
                        <div class="achievement-title">{{ item.title }}</div>
                        <div class="achievement-tags">
                            <span class="achievement-tag" v-for="(tag, tIndex) in item.tags" :key="tIndex">{{ tag }}</span>
                        </div>
                    </div>
                </div>

                <!-- 暂无数据 -->
                <div class="empty-state" v-if="!loading && activeTab !== 'achievement' && dataList.length === 0">
                    <div class="empty-icon">
                        <img src="@/assets/image/data_empty.png" alt="暂无数据" />
                    </div>
                    <div class="empty-text">暂无数据</div>
                </div>

                <!-- 分页 -->
                <div class="pagination-wrapper" v-if="activeTab !== 'achievement' && total > 0">
                    <pagination :background="false"
                        :pageSizes="[12, 24, 36]"
                        :total="total"
                        v-model:page.sync="queryParams.pageNum"
                        v-model:limit.sync="queryParams.pageSize"
                        @pagination="pageList" />
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { pageRaceWeb } from "@/api/admin/race";
import { activityPageWeb } from "@/api/admin/activity";
import { queryDict } from "@/api/admin/dict";
import { timestampToTime } from "@/utils/date";
import homeHead from "@/components/common/homeHead.vue";

export default {
    components: { homeHead },
    name: "eduResearch",
    data() {
        return {
            loading: false,
            activeTab: "race",
            total: 0,
            dataList: [],
            levelList: [],
            directionList: [],
            statusList: [],
            queryParams: {
                status: "",
                level: "",
                direction: "",
                name: "",
                pageNum: 1,
                pageSize: 12,
            },
            defaultCover: require("@/assets/logo/logo.png"),
            achievementList: [
                { title: "过程性成果", tags: ["赛事方案", "组织实施", "过程资料"] },
                { title: "学生素养成果", tags: ["阅读作品", "特色创作", "实践成果", "成长记录"] },
                { title: "资源沉淀成果", tags: ["课程资源", "研学资源", "成果汇编"] },
                { title: "宣传与佐证材料", tags: ["赛事方案", "影像资料", "总结材料"] },
            ],
        };
    },
    computed: {},
    watch: {
        "$route.query": {
            handler(newQuery) {
                if (!newQuery || this.isQuerySameAsCurrent(newQuery)) return;
                this.restoreFromQuery(newQuery);
            },
        },
    },
    created() {
        this.restoreFromQuery();
    },
    mounted() {},
    methods: {
        /* ===============字典查询===================== */
        loadDict() {
            const levelCode = this.activeTab === "race" ? "race_level" : "activity_level";
            const directionCode = this.activeTab === "race" ? "race_direction" : "activity_direction";
            this.levelList = [];
            this.directionList = [];
            this.statusList = this.activeTab === "race"
                ? [
                    { name: "报名阶段", value: 1 },
                    { name: "初审阶段", value: 2 },
                    { name: "复审阶段", value: 3 },
                    { name: "终审阶段", value: 4 },
                    { name: "现场评比", value: 5 },
                    { name: "竞赛结束", value: 6 },
                ]
                : [
                    { name: "报名阶段", value: 1 },
                    { name: "初审阶段", value: 2 },
                    { name: "复审阶段", value: 3 },
                    { name: "终审阶段", value: 4 },
                    { name: "现场评比", value: 5 },
                    { name: "活动结束", value: 6 },
                ];
            queryDict({ code: levelCode }).then(res => {
                if (res.data && res.data.code === 1) {
                    this.levelList = res.data.data || [];
                }
            });
            queryDict({ code: directionCode }).then(res => {
                if (res.data && res.data.code === 1) {
                    this.directionList = res.data.data || [];
                }
            });
        },

        /* ===============切换标签===================== */
        changeTab(tab) {
            if (this.activeTab === tab) return;
            this.activeTab = tab;
            if (tab !== "achievement") {
                this.queryParams = {
                    status: "",
                    level: "",
                    direction: "",
                    name: "",
                    pageNum: 1,
                    pageSize: 12,
                };
                this.loadDict();
                this.pageList();
            } else {
                this.loadDict();
                this.syncQueryToUrl();
            }
        },

        /* ===============将当前查询条件同步到 URL===================== */
        syncQueryToUrl() {
            const query = { ...this.$route.query };
            query.tab = this.activeTab;
            const setQuery = (key, value) => {
                if (value !== undefined && value !== null && value !== "") {
                    query[key] = value;
                } else {
                    delete query[key];
                }
            };
            if (this.activeTab !== "achievement") {
                setQuery("status", this.queryParams.status);
                setQuery("level", this.queryParams.level);
                setQuery("direction", this.queryParams.direction);
                setQuery("name", this.queryParams.name);
                query.pageNum = this.queryParams.pageNum;
                query.pageSize = this.queryParams.pageSize;
            } else {
                ["status", "level", "direction", "name", "pageNum", "pageSize"].forEach(key => delete query[key]);
            }
            this.$router.replace({ query }).catch(() => {});
        },

        /* ===============判断 URL 查询是否与当前状态一致===================== */
        isQuerySameAsCurrent(query) {
            const q = query || {};
            if ((q.tab || "race") !== this.activeTab) return false;
            if (this.activeTab === "achievement") return true;
            const fields = ["status", "level", "direction", "name"];
            for (const f of fields) {
                const qv = q[f] === undefined || q[f] === null || q[f] === "" ? undefined : String(q[f]);
                const pv = this.queryParams[f] === undefined || this.queryParams[f] === null || this.queryParams[f] === "" ? undefined : String(this.queryParams[f]);
                if (qv !== pv) return false;
            }
            const pageNum = Number(q.pageNum) || 1;
            const pageSize = Number(q.pageSize) || 12;
            return pageNum === Number(this.queryParams.pageNum) && pageSize === Number(this.queryParams.pageSize);
        },

        /* ===============从 URL 查询中恢复查询条件===================== */
        restoreFromQuery(query = this.$route.query) {
            const q = query || {};
            const tab = q.tab;
            if (tab && ["race", "activity", "achievement"].includes(tab)) {
                this.activeTab = tab;
            }
            if (this.activeTab !== "achievement") {
                ["status", "level", "direction", "name"].forEach(key => {
                    if (q[key] !== undefined && q[key] !== null) {
                        this.queryParams[key] = q[key];
                    }
                });
                this.queryParams.pageNum = Number(q.pageNum) || 1;
                this.queryParams.pageSize = Number(q.pageSize) || 12;
            }
            this.loadDict();
            if (this.activeTab !== "achievement") {
                this.pageList();
            }
        },

        /* ===============分页查询===================== */
        pageList(e) {
            if (this.activeTab === "achievement") return;
            this.loading = true;
            this.dataList = [];
            if (e) {
                this.queryParams.pageNum = e.page;
                this.queryParams.pageSize = e.limit;
            }
            this.syncQueryToUrl();
            const params = this.buildParams();
            const request = this.activeTab === "race" ? pageRaceWeb(params) : activityPageWeb(params);
            request.then(res => {
                if (res.data && res.data.code === 1) {
                    this.total = res.data.data.total || 0;
                    this.dataList = res.data.data.list || [];
                } else {
                    this.$message.error(res.data.msg || "请求出错");
                }
                this.loading = false;
            }).catch(() => {
                this.loading = false;
            });
        },

        buildParams() {
            const params = {
                pageNum: this.queryParams.pageNum,
                pageSize: this.queryParams.pageSize,
                status: this.queryParams.status,
                name: this.queryParams.name,
            };
            if (this.activeTab === "race") {
                params.raceLevel = this.queryParams.level;
                params.raceDirection = this.queryParams.direction;
            } else {
                params.activityLevel = this.queryParams.level;
                params.activityDirection = this.queryParams.direction;
            }
            return params;
        },

        /* ===============筛选与搜索===================== */
        handleFilterChange() {
            this.queryParams.pageNum = 1;
            this.pageList();
        },
        handleSearch() {
            this.queryParams.pageNum = 1;
            this.pageList();
        },

        /* ===============工具方法===================== */
        formatTimeRange(item) {
            const begin = item.beginTime ? timestampToTime(item.beginTime) : "";
            const end = item.endTime ? timestampToTime(item.endTime) : "";
            if (begin && end) return begin + "至" + end;
            return begin || end || "--";
        },
        statusLabel(status) {
            const map = {
                0: "初始阶段",
                1: "报名阶段",
                2: "初审阶段",
                3: "复审阶段",
                4: "终审阶段",
                5: "现场评比",
                6: "已结束",
            };
            return map[status] || "报名阶段";
        },
        statusClass(status) {
            if (status === 1) return "status-signup";
            if (status === 2 || status === 3 || status === 4) return "status-review";
            if (status === 5) return "status-site";
            if (status === 6) return "status-end";
            return "status-signup";
        },

        /* ===============跳转===================== */
        goHome() {
            this.$router.push("/museum/home");
        },
        handleCardClick(item) {
            if (this.activeTab === 'race') {
                this.$router.push({
                    path: '/edu/eduRaceInfo',
                    query: { raceId: item.raceId }
                });
            } else if (this.activeTab === 'activity') {
                this.$router.push({
                    path: '/edu/eduActivityInfo',
                    query: { activityId: item.activityId }
                });
            }
        },
        handleAchievementClick(item) {
            // TODO: 跳转成果分类页
            console.log("achievement click", item);
        },
    }
}
</script>

<style scoped>
.edu-research-page {
    width: 100%;
    height: 100vh;
    display: flex;
    flex-direction: column;
    overflow: hidden;
}

.edu-research-body {
    flex: 1;
    min-height: 0;
    width: 100%;
    background-color: #fdfcf8;
    display: flex;
    justify-content: center;
    align-items: flex-start;
    padding: 30px 0 80px 0;
    box-sizing: border-box;
    overflow: hidden;
}

.edu-research-inner {
    width: 100%;
    max-width: 1200px;
    height: 100%;
    margin: 0 auto;
    padding: 0 20px 50px 20px;
    box-sizing: border-box;
    display: flex;
    flex-direction: column;
    position: relative;
}

/* 标题区 */
.edu-research-header {
    width: 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 20px;
    flex-shrink: 0;
}

.edu-research-title-box {
    display: flex;
    flex-direction: column;
}

.edu-research-title {
    font-size: 24px;
    color: #b22222;
    font-weight: bold;
    font-family: sans-serif;
    letter-spacing: 2px;
    margin-bottom: 6px;
}

.edu-research-subtitle {
    font-size: 14px;
    color: #9ca3af;
    font-family: sans-serif;
    letter-spacing: 1px;
}

.edu-research-actions {
    display: flex;
    align-items: center;
}

.back-btn {
    height: 36px;
    line-height: 36px;
    padding: 0 32px;
    background-color: #b22222;
    color: #ffffff;
    border-radius: 4px;
    font-size: 14px;
    font-family: sans-serif;
    cursor: pointer;
    display: flex;
    align-items: center;
    transition: all 0.2s ease;
}

.back-btn:hover {
    background-color: #9a1b1b;
}

/* 标签切换 */
.edu-research-tabs {
    width: 100%;
    display: flex;
    align-items: center;
    gap: 16px;
    margin-bottom: 20px;
    flex-shrink: 0;
}

.tab-item {
    min-width: 110px;
    height: 36px;
    line-height: 34px;
    padding: 0 20px;
    text-align: center;
    border: 1px solid #b22222;
    border-radius: 4px;
    font-size: 14px;
    color: #b22222;
    background-color: #ffffff;
    font-family: sans-serif;
    cursor: pointer;
    transition: all 0.2s ease;
    box-sizing: border-box;
}

.tab-item:hover {
    background-color: #fff5f5;
}

.tab-item.active {
    background-color: #b22222;
    color: #ffffff;
    border-color: #b22222;
}

/* 筛选工具栏 */
.edu-research-filter {
    width: 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 20px;
    flex-shrink: 0;
}

.filter-left {
    display: flex;
    align-items: center;
    gap: 20px;
}

.filter-item {
    display: flex;
    align-items: center;
    gap: 10px;
}

.filter-label {
    font-size: 15px;
    color: #4b5563;
    font-family: sans-serif;
    white-space: nowrap;
}

.filter-select {
    width: 140px !important;
}

.filter-select .el-select__wrapper {
    min-height: 36px !important;
    height: 36px;
    line-height: 36px;
    font-size: 14px;
}

.filter-right {
    display: flex;
    align-items: center;
    gap: 10px;
}

.search-input {
    width: 240px;
    height: 34px;
    line-height: 34px;
    padding: 0 12px;
    border: 1px solid #d1d5db;
    border-radius: 4px;
    outline: none;
    font-size: 14px;
    font-family: sans-serif;
    box-sizing: border-box;
    background-color: #ffffff;
}

.search-input:focus {
    border-color: #b22222;
}

.search-btn {
    height: 34px;
    line-height: 34px;
    padding: 0 22px;
    border: 1px solid #b22222;
    border-radius: 4px;
    font-size: 14px;
    color: #b22222;
    background-color: #ffffff;
    font-family: sans-serif;
    cursor: pointer;
    transition: all 0.2s ease;
    box-sizing: border-box;
}

.search-btn:hover {
    background-color: #b22222;
    color: #ffffff;
}

/* 赛事/活动列表 */ 
.event-list {
    width: 100%;
    flex: 1;
    min-height: 0;
    display: grid;
    grid-template-columns: repeat(4, minmax(0, 1fr));
    gap: 20px;
    box-sizing: border-box;
    overflow-y: auto;
    overflow-x: hidden;
    padding-bottom: 60px;
    padding-top: 10px;
    align-content: flex-start;
}

.event-list::-webkit-scrollbar {
    width: 10px;
    height: 10px;
}

.event-list::-webkit-scrollbar-track {
    background: #f1f1f1;
    border-radius: 6px;
}

.event-list::-webkit-scrollbar-thumb {
    background: #b22222;
    border-radius: 6px;
    border: 3px solid #f1f1f1;
}

.event-list::-webkit-scrollbar-thumb:hover {
    background: #9a9a9a;
}

.event-card {
    width: 100%;
    display: flex;
    flex-direction: column;
    background-color: #ffffff;
    border: 1.5px solid #b22222;
    border-radius: 4px;
    box-sizing: border-box;
    padding: 14px;
    cursor: pointer;
    transition: all 0.25s ease;
}

.event-card:hover {
    transform: translateY(-4px);
    box-shadow: 0 8px 24px rgba(0, 0, 0, 0.1);
}

.card-title {
    width: 100%;
    font-size: 16px;
    font-weight: bold;
    color: #1f2937;
    font-family: sans-serif;
    line-height: 1.5;
    margin-bottom: 8px;
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
}

.card-time {
    width: 100%;
    font-size: 13px;
    color: #4b5563;
    font-family: sans-serif;
    margin-bottom: 10px;
}

.card-cover {
    width: 100%;
    aspect-ratio: 16 / 9;
    display: flex;
    align-items: center;
    justify-content: center;
    overflow: hidden;
    margin-bottom: 12px;
    background-color: #f3f4f6;
    border-radius: 4px;
    position: relative;
}

.card-cover img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    display: block;
}

.card-status {
    position: absolute;
    right: 10px;
    bottom: 10px;
    min-width: 70px;
    height: 26px;
    line-height: 26px;
    padding: 0 12px;
    border-radius: 13px;
    font-size: 12px;
    color: #ffffff;
    text-align: center;
    font-family: sans-serif;
    background-color: #4095e5;
}

.status-signup {
    background-color: #4095e5;
}

.status-review {
    background-color: #ffbf6b;
}

.status-site {
    background-color: #81b337;
}

.status-end {
    background-color: #9ca3af;
}

.card-info {
    width: 100%;
    display: flex;
    flex-direction: column;
    gap: 6px;
}

.card-info-item {
    width: 100%;
    font-size: 13px;
    color: #1f2937;
    font-family: sans-serif;
    line-height: 1.5;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}

.info-label {
    color: #4b5563;
}

.info-value {
    color: #1f2937;
}

/* 成果展示 */
.achievement-list {
    width: 100%;
    flex: 1;
    min-height: 0;
    display: grid;
    grid-template-columns: repeat(4, minmax(0, 1fr));
    gap: 20px;
    box-sizing: border-box;
    overflow-y: auto;
    overflow-x: hidden;
    padding-bottom: 100px;
    padding-top: 10px;
    align-content: flex-start;
}

.achievement-card {
    width: 100%;
    min-height: 180px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    background-color: #ffffff;
    border: 1.5px solid #b22222;
    border-radius: 4px;
    box-sizing: border-box;
    padding: 24px 16px;
    cursor: pointer;
    transition: all 0.25s ease;
    gap: 18px;
}

.achievement-card:hover {
    transform: translateY(-4px);
    box-shadow: 0 8px 24px rgba(0, 0, 0, 0.1);
}

.achievement-title {
    font-size: 22px;
    font-weight: bold;
    color: #b22222;
    font-family: sans-serif;
    letter-spacing: 2px;
    text-align: center;
}

.achievement-tags {
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    gap: 10px;
}

.achievement-tag {
    font-size: 14px;
    color: #4b5563;
    font-family: sans-serif;
}

/* 暂无数据 */
.empty-state {
    width: 100%;
    flex: 1;
    min-height: 0;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    padding-bottom: 100px;
    box-sizing: border-box;
}

.empty-icon {
    width: 120px;
    height: 120px;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-bottom: 16px;
}

.empty-icon img {
    max-width: 100%;
    max-height: 100%;
    object-fit: contain;
}

.empty-text {
    font-size: 15px;
    color: #9ca3af;
    font-family: sans-serif;
    letter-spacing: 1px;
}

/* 分页 */
.pagination-wrapper {
    position: absolute;
    left: 0;
    right: 0;
    bottom: -60px;
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 100;
}

.pagination-wrapper .el-pagination__total {
    font-size: 13px;
    color: #6b7280;
}

.pagination-wrapper .el-pagination__jump {
    font-size: 13px;
    color: #6b7280;
}

.pagination-wrapper .el-pager li {
    font-size: 13px;
    color: #4b5563;
}

.pagination-wrapper .el-pager li.active {
    background-color: #b22222;
    color: #ffffff;
}

.pagination-wrapper .el-select .el-input__wrapper {
    height: 28px;
    min-height: 28px;
    font-size: 13px;
}

@media (max-width: 1280px) {
    .edu-research-inner { padding: 0 20px; }
    .edu-research-title { font-size: 22px; }
    .event-list { gap: 16px; }
    .achievement-list { gap: 16px; }
    .filter-left { gap: 14px; }
    .filter-select { width: 120px !important; }
    .search-input { width: 200px; }
}

@media (max-width: 1024px) {
    .edu-research-title { font-size: 20px; }
    .edu-research-subtitle { font-size: 13px; }
    .edu-research-filter { flex-wrap: wrap; gap: 12px; }
    .filter-left { gap: 12px; }
    .filter-select { width: 100px !important; }
    .search-input { width: 160px; }
    .event-list { grid-template-columns: repeat(3, minmax(0, 1fr)); gap: 12px; }
    .achievement-list { grid-template-columns: repeat(2, minmax(0, 1fr)); gap: 12px; }
    .achievement-title { font-size: 18px; }
}

@media (max-width: 768px) {
    .edu-research-header { flex-direction: column; align-items: flex-start; gap: 12px; }
    .edu-research-tabs { flex-wrap: wrap; }
    .edu-research-filter { flex-direction: column; align-items: flex-start; }
    .filter-left { flex-wrap: wrap; }
    .filter-right { width: 100%; }
    .search-input { flex: 1; }
    .event-list { grid-template-columns: repeat(2, minmax(0, 1fr)); gap: 10px; }
    .achievement-list { grid-template-columns: repeat(1, minmax(0, 1fr)); gap: 10px; }
    .event-card { padding: 10px; }
    .card-info-item { font-size: 12px; }
}
</style>
